import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * When the current URL contains `?new=1`, invoke `onOpen` once and strip the
 * query param from the address bar so a refresh doesn't re-trigger it.
 * Used by list pages (articles, clients, suppliers, representatives) to open
 * their creation dialog from a quick-link.
 */
export function useOpenCreateFromQuery(onOpen: () => void) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('new') !== '1') return;
    onOpen();
    params.delete('new');
    const qs = params.toString();
    navigate(
      { pathname: location.pathname, search: qs ? `?${qs}` : '' },
      { replace: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once per mount.
  }, []);
}
